/* eslint-disable */

import { mocks } from './Setup';

export function disable(target, name, descriptor) {
  descriptor.value = () => 'OFF';
  return descriptor;
}

export function enable(target, name, descriptor) {
  const oldFN = descriptor.value;

  descriptor.value = function() {
    const Obj = mocks[target.constructor.name];

    if (Obj === undefined) return;

    if (Obj[oldFN.name] !== undefined) {
      Obj[oldFN.name] = oldFN;
    }

    if (Obj.prototype && Obj.prototype[oldFN.name] !== undefined) {
      Obj.prototype[oldFN.name] = oldFN;
    }
  };

  return descriptor;
}
